const setupCounterUp = async (
    {delay, duration, threshold} = {
        delay: 16,
        duration: 1000,
        threshold: 0.25,
    },
) => {
    const els = [...document.querySelectorAll(".animated-num")];
    if (0 === els.length) {
        return;
    }

    const {default: counterUp} = await import("counterup2");
    const IO = new IntersectionObserver(
        (entries) => {
            [...entries].forEach((entry) => {
                if (entry.intersectionRatio >= threshold) {
                    counterUp(entry.target, {delay, duration});
                }
            });
        },
        {threshold},
    );
    els.forEach((el) => IO.observe(el));
};

export default setupCounterUp;
